import React from 'react';
import Title from '../../shared/Title';

import { useQuery } from 'react-query';
import { getClients } from '../../../services/clientsApi';
import GridLayout from '../../team/GridLayout';
import Loading from '../../shared/Loading';
import Alert from '../../shared/Alert';

const Clients = () => {
  const { isLoading, isError, data } = useQuery(['clients', { order: [{ by: 'Order', type: 'asc' }] }], getClients, {
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return (
    <div className="bg-no-repeat bg-cover">
      <div className="3xl:max-w-[1500px] 3xl:inline-block xl:px-52 md:px-20 px-10 my-20" >
        <div className='flex flex-col mb-10'>
          <Title text1="Our" text2="Clients" colorForText={2} />
          <p className="text-light-grey-600 text-xl text-center "> We are a customer-centric company and our goal is to align our </p>
          <p className="text-light-grey-600 text-xl text-center "> capabilities with your digital strategy. We develop high-level digital</p>
          <p className="text-light-grey-600 text-xl text-center "> products, support strategic projects, and provide the best talent.</p>
        </div>
        {isLoading ? (
          <Loading />
        ) : isError ? (
          <Alert open={isError} severity="warning" message="Error loading data, try again later" />
        ) : data && data.data.length > 0 ? (
          <div className="w-full flex justify-center">
            <GridLayout gridClassName="grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-16">
              {data.data.map((client) => (
                <div key={client.Id} className="flex justify-center items-center">
                  <img
                    src={client.LogoUrl}
                    alt={client.Name}
                    className="w-[140px] sm:w-[160px] md:w-[195px] h-auto object-contain transition-transform duration-200 hover:scale-105"
                  />
                </div>
              ))}
            </GridLayout>
          </div>
        ) : (
          <Alert open={true} message="No metrics available at this time" severity="info" />
        )}
      </div>
    </div>
  );
};

export default Clients;
